import { useMutation } from '@tanstack/react-query';
import { ratingRequest } from '@worker/services/rating/api';
import IRatingRequestCreation from '@worker/types/rating-request-creation.type';
import useNotification from '@hooks/useNotification';

interface RatingRequestMutationVariables {
  jobAssignmentId: number;
  body: IRatingRequestCreation;
}

interface UseRatingRequestMutationOptions {
  onSuccess?: () => void;
}

export function useRatingRequestMutation(
  options?: UseRatingRequestMutationOptions
) {
  const { showSuccessNotification, showErrorNotification } = useNotification();

  return useMutation<unknown, Error, RatingRequestMutationVariables>({
    mutationFn: async ({ jobAssignmentId, body }) => {
      const result = await ratingRequest(jobAssignmentId, body);

      if (!result || result.success === false) {
        throw new Error(
          result?.message || 'Could not send your request. Please try again.'
        );
      }
      return result;
    },

    onError: (error) => {
      showErrorNotification(error.message, { title: 'Could not send request' });
    },

    onSuccess: () => {
      showSuccessNotification("We'll let the company know.", {
        title: 'Request sent',
      });
      options?.onSuccess?.();
    },
  });
}
